import React, { useState } from 'react'
import { Helmet } from 'react-helmet-async'

import LCL from '../../assets/images/services/ni-loading.jpg'
import FCL from '../../assets/images/services/pre-inspect.jpg'
import SPS from '../../assets/images/services/inspect.jpg'
import TSADD from '../../assets/images/services/laboratory.jpg'
import CC from '../../assets/images/services/cert.jpg'

import { ReactComponent as Icon } from '../../assets/images/svg/what-we-offer.svg'

import CardComponent from '../../components/ServicesCard'

const Services = () => {
  const [lcl, setLcl] = useState(false)
  const [fcl, setFcl] = useState(false)
  const [sps, setSps] = useState(false)
  const [tsadd, setTsadd] = useState(false)
  const [cc, setCc] = useState(false)

  const handleExpandlcl = () => {
    setLcl(!lcl)
    setFcl(false)
    setSps(false)
    setTsadd(false)
    setCc(false)
  }

  const handleExpandfcl = () => {
    setLcl(false)
    setFcl(!fcl)
    setSps(false)
    setTsadd(false)
    setCc(false)
  }

  const handleExpandsps = () => {
    setLcl(false)
    setFcl(false)
    setSps(!sps)
    setTsadd(false)
    setCc(false)
  }

  const handleExpandtsadd = () => {
    setLcl(false)
    setFcl(false)
    setSps(false)
    setTsadd(!tsadd)
    setCc(false)
  }

  const handleExpandcc = () => {
    setLcl(false)
    setFcl(false)
    setSps(false)
    setTsadd(false)
    setCc(!cc)
  }

  return (
    <div className='Services' id='services'>
      <Helmet>
        <title>Our Services | NEOVERA SURVEYING CORPORATION</title>
        <meta
          name="description"
           content="NEOVERA SURVEYING CORPORATION provides independent sampling, surveying, and testing services. From cargo hold assessment, sampling, inspection, draft surveys, to P&I and pre-loading surveys, we ensure international standards and reliable cargo quality."
        />
        <link rel="canonical" href="https://neoveracsc.com/#services" />
      </Helmet>

      <div className='Services__item'>
        <h2 className='headingH2'>
          <Icon className='icon' />
          What We Offer?
        </h2>
        <div className='Services__item--content'>
          <p>
          NEOVERA SURVEYING CORPORATION conducts and provides independent sampling, surveying, and testing services to aid in maintaining the quantity and quality of our customer's cargoes. We adopt a systematic approach to ensure that our work meets international standards. From cargo hold assessment, sampling, inspection, draft surveys, to P&I and pre-loading surveys, our inspectors supervise and uphold work reflecting years of expertise.
          </p>
        </div>
      </div>
      <div className='Services__item'>
        <CardComponent
          image={LCL}
          alt='MINERAL LOADING'
          heading='MINERAL LOADING'
          content='With mastery in nickel loading, our highly trained personnel can assist in the sampling and testing of nickel.'
          onClick={handleExpandlcl}
          expand={lcl}
          aria={lcl}
          collapse={lcl}
        />

        <CardComponent
          image={FCL}
          alt='PRE-SHIPMENT INSPECTION'
          heading='PRE-SHIPMENT INSPECTION'
          content='Independent pre-shipment inspection services are provided for mineral commodities. Through precise stockpile sampling and laboratory analysis, we deliver accurate and reliable results that ensure our clients know the true quality of their shipments.'
          onClick={handleExpandfcl}
          expand={fcl}
          aria={fcl}
          collapse={fcl}
        />

        <CardComponent
          image={SPS}
          alt='P&I INSPECTION'
          heading='P&I INSPECTION'
          content="Through our P&I inspections, we uphold the highest standards, safeguarding our client's interests. Our surveyors, equipped with knowledge and years of field experience, conduct the Can Test to identify wet cargo and monitor the entire loading operation."
          onClick={handleExpandsps}
          expand={sps}
          aria={sps}
          collapse={sps}
        />

        <CardComponent
          image={TSADD}
          alt='LABORATORY TESTING'
          heading='LABORATORY TESTING'
          content='Our testing facilities employs XRF together with the Chemical Method in the analysis of mineral ores. We have an established full laboratory in Surigao and Manila catering to the market demand.'
          onClick={handleExpandtsadd}
          expand={tsadd}
          aria={tsadd}
          collapse={tsadd}
        />

        <CardComponent
          image={CC}
          alt='CERTIFICATION AND REPORT'
          heading='CERTIFICATION AND REPORT'
          content={
            <>
              <p>
                Together with our laboratory testing, we also provide certificates verifying both the quantity and quality of products adhering to our client's criteria and industry standards.
              </p>
              <br></br>
              <ul>
                <li>
                  Loading Inspection
                  {/* <ul>
                    <li>Certificate Of Quality</li>
                    <li>Certificate Of Weight</li>
                  </ul> */}
                </li>
                <li>
                  Pre-Shipment Inspection
                  {/* <ul>
                    <li>Pre-Inspection Certificate</li>
                  </ul> */}
                </li>
                <li>
                  Analysis Report
                  {/* <ul>
                    <li>Analysis Report</li>
                  </ul> */}
                </li>
              </ul>
            </>
          }
          onClick={handleExpandcc}
          expand={cc}
          aria={cc}
          collapse={cc}
        />
      </div>
    </div>
  )
}

export default Services
